import { Component } from 'react';

import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

@inject((stores) => ({
  onlineEvent: stores.MembershipStore.onlineEvent
}))
export default class DisabledOnOnlineEvent extends Component {
  static propTypes = {
    children: PropTypes.node,
    onlineEvent: PropTypes.bool
  };

  static defaultProps = {
    onlineEvent: false
  };

  render() {
    const { children, onlineEvent } = this.props;

    if (onlineEvent) {
      return null;
    }

    return children;
  }
}
